import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSocket } from '../../contexts/SocketContext';
import { useAuth } from '../../shared/contexts/AuthContext';
import { globalPttService } from '../../services/ptt/globalPttService';

export function GlobalPttBootstrap() {
  const { socket, isConnected } = useSocket();
  const { user, loading } = useAuth();
  const location = useLocation();
  const isLogin = location.pathname === '/login';
  const userId = user?._id || '';

  useEffect(() => {
    if (loading || isLogin || !isConnected || !socket || !userId) {
      if (isLogin || (!loading && !userId)) {
        globalPttService.destroy();
      }
      return;
    }
    void globalPttService.init(socket, userId);
  }, [loading, isLogin, isConnected, socket, userId]);

  return null;
}
